import ChargeDriverDetailView from 'features/Charge/ChargeDriver/components/ChargeDriverDetailView';
import useRouter from 'hooks/useRouter';

FleetDriverDetailScreen.propTypes = {};

function FleetDriverDetailScreen(props) {
    // MARK: ---- PROPERTIES ----
    const router = useRouter();
    const driverId = router.query?.driverId;

    return <ChargeDriverDetailView driverId={driverId} />;
}

export default FleetDriverDetailScreen;
